module.exports = __webpack_public_path__ + "static/media/Page_Background.ffb394a4.jpg";